exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-1-form[data-v-60a9fd93]{flex-direction:column}@media screen and (min-width:1024px){.step-1-form[data-v-60a9fd93]{flex-direction:row}}@media screen and (min-width:1024px){.step-1-form .form-fields[data-v-60a9fd93]{width:40%}}@media screen and (min-width:1024px){.step-1-form .car-preview[data-v-60a9fd93]{width:60%}}", ""]);

// exports
